module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("Uncaught SyntaxError: Unexpected token export")]), _vm._v(" "), _c('p', [_vm._v("原因是Vux的js源码没配置babel，你可以在webpack配置的loaders加上")]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_vm._v("{\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("test")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-regexp"
  }, [_vm._v("/vux.src.*?js$/")]), _vm._v(",\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("loader")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'babel'")]), _vm._v("\n}\n")])]), _vm._v(" "), _c('p', [_vm._v("或者启用"), _c('code', [_vm._v("vux-loader")]), _vm._v("的"), _c('code', [_vm._v("vux-ui")]), _vm._v("插件。")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-45c63a36", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/ream/~/vue-loader/lib/template-compiler?{"id":"data-v-45c63a36"}!./~/ream/~/vue-loader/lib/selector.js?type=template&index=0!./~/v-markdown-loader/_cache/Uncaught-SyntaxError-Unexpected-token-export-16.vue
// module id = 2202
// module chunks = 473